import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../../../../assets/css/screens/serviceprovider/dashboard/settings/Settings.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import AppContext from '../../../../context/AppContext';

// ── Import Broken-down Sections ──
// import NotificationsSection from '../../../../components/serviceprovider/workerdashboard/workersetting/NotificationsSection';
// import PreferencesSection from '../../../../components/serviceprovider/workerdashboard/workersetting/PreferencesSection';
import PrivacySection from '../../../../components/serviceprovider/workerdashboard/workersetting/PrivacySection';
import AccountSection from '../../../../components/serviceprovider/workerdashboard/workersetting/AccountSection';
import { ArrowLeft } from 'lucide-react';

const Settings = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken, RegExpChecker } = useContext(AppContext);

  const [push_notifications, setPush_notifications] = useState(false);
  const [email_notifications, setEmail_notifications] = useState(false);
  const [availablity, setAvailablity] = useState(false);

  const [saved, setSaved] = useState(false);

  const [showChangePw, setShowChangePw] = useState(false);
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState(false);
  const [pwLoading, setPwLoading] = useState(false);

  const handleBack = () => navigate(-1);

  const view = () => {
    axios.get(
      `${baseUrl}/worker/setting`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        const data = res.data.setting;

        setPush_notifications(data.push_notifications);
        setEmail_notifications(data.email_notifications);
        setAvailablity(data.availablity);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateSetting = (pushValue = push_notifications, emailValue = email_notifications, availableValue = availablity) => {

    const formData = new FormData();

    formData.append('push_notifications', pushValue ? 1 : 0);
    formData.append('email_notifications', emailValue ? 1 : 0);
    formData.append('availablity', availableValue ? 1 : 0);

    axios.post(
      `${baseUrl}/worker/updatesetting`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        localStorage.setItem(
          "availability",
          availableValue ? "1" : "0"
        );

        setSaved(true);

      })
      .catch((error) => {

        console.log("Full Error:", error);
        console.log("Response:", error.response);
        console.log("Data:", error.response?.data);

        alert("Error");
      });
  };

  const handleChangePassword = () => {
    setShowChangePw(p => !p);
    setPwError(''); setPwSuccess(false);
    setPwForm({ current: '', newPw: '', confirm: '' });
  };

  const handlePwSubmit = async () => {
    
    setPwError('');

    const passwordValidation = RegExpChecker("password", pwForm.newPw);

if (passwordValidation.password) {
    setPwError(passwordValidation.password);
    return;
}

    if (!pwForm.current || !pwForm.newPw || !pwForm.confirm) {
      setPwError('Please fill in all fields.');
      return;
    }
    if (pwForm.newPw !== pwForm.confirm) {
      setPwError('New passwords do not match.');
      return;
    }
    setPwLoading(true);
    axios.post(
      `${baseUrl}/worker/updatepassword`,
      {
        current_password: pwForm.current,
        new_password: pwForm.newPw,
      },
      {
        headers: { Authorization: `Bearer ${authToken}` }
      }
    )
      .then((res) => {
        if (res.data.success) {

          localStorage.setItem("password", res.data.password);

          setPwSuccess(true);
          setPwForm({
            current: '',
            newPw: '',
            confirm: ''
          });

          setTimeout(() => {
            setShowChangePw(false);
            setPwSuccess(false);
          }, 2000);
        } else {
          setPwError(res.data.message || 'Password update failed');
        }
      })
      .catch((err) => {

        setPwError(
          err.response?.data?.message ||
          "Unable to update password."
        );

      })
      .finally(() => {

        setPwLoading(false);

      });
  };

  /* ── Delete Account — SweetAlert2 ── */
  const handleDeleteAccount = () => {
    Swal.fire({
      title: 'Delete Account?',
      html: `
      <p style="color:#484745;margin:0;line-height:1.6;">
        This will <strong>permanently remove</strong> your account,
        all your jobs, earnings, and data.<br/>
        <span style="color:#dc2626;">This action cannot be undone.</span>
      </p>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    }).then((result) => {

      if (result.isConfirmed) {

        axios.delete(`${baseUrl}/worker/deleteAccount`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        })

          .then((res) => {

            if (res.data.success) {

              localStorage.removeItem("authToken");

              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your account has been deleted.',
                timer: 1500,
                showConfirmButton: false
              });

              navigate('/');
            }

          })

          .catch((err) => {
            console.log(err.response?.data || err.message);


          });
      }
    });
  };

  /* ── Logout — navigate to landing ── */
  const handleLogout = async () => {

    const result = await Swal.fire({
      title: 'Log Out?',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });

    if (!result.isConfirmed) return;

    try {

      const res = await axios.post(
        `${baseUrl}/worker/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      if (res.data.success) {

        localStorage.removeItem("authToken");

        await Swal.fire({
          icon: 'success',
          title: 'Logged Out',
          text: 'You have been logged out successfully',
          timer: 1500,
          showConfirmButton: false
        });

        navigate('/');
      }
    } catch (err) {

      console.log("LOGOUT ERROR:", err.response?.data || err.message);
    }
  };
  useEffect(() => {
    view();
  }, []);
  return (
    <>
      <WorkerNavbar />
      <div className="settings-page">

        <div className="settings-header">
          <button className="settings-back-btn" onClick={handleBack}><ArrowLeft size={24} /></button>
          <h2 className="settings-title">Settings</h2>
        </div>

        <div className="settings-content">

          {/* <NotificationsSection
            push_notifications={push_notifications}
            setPush_notifications={setPush_notifications}
            email_notifications={email_notifications}
            setEmail_notifications={setEmail_notifications}
            availablity={availablity}
            updateSetting={updateSetting}
          /> */}

          {/* <PreferencesSection
            push_notifications={push_notifications}
            email_notifications={email_notifications}
            availablity={availablity}
            setAvailablity={setAvailablity}
            updateSetting={updateSetting}
          /> */}

          <PrivacySection
            showChangePw={showChangePw}
            setShowChangePw={setShowChangePw}
            handleChangePassword={handleChangePassword}
            pwForm={pwForm}
            setPwForm={setPwForm}
            pwError={pwError}
            pwSuccess={pwSuccess}
            pwLoading={pwLoading}
            handlePwSubmit={handlePwSubmit}
          />

          <AccountSection handleDeleteAccount={handleDeleteAccount} />

          <button className="settings-logout-btn" onClick={handleLogout}>
            <LogOut size={18} /> Log Out
          </button>

        </div>
      </div>
    </>
  );
};

export default Settings;